import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export class SpecialFilter<TItem extends CardVariant> implements IFilterCommand<TItem, void> {
    isMatch(item: TItem, args: void): boolean {
        const text = item?.card?.text || "";
        return text.includes("{specialicon}");
    }
}